export default "__VITE_ASSET__BZE63HKp__"